import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchFrameworkObject, fetchGeneralObject } from "../Redux/slices/otherSlice";
import { Link } from "react-router-dom";


const FrameworkRap = styled.div`
.frame-1 h2 {
font-size: 60px;
line-height: 60px;
max-width: 767px;
text-align: center;
color: #1B2A50;

}
.frame-1 p {
    color: #565E6F;
    font-size: 18px;
    font-weight: 400;
    max-width: 729px;
    text-align: center;
    line-height: 24px;

}
.frame-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    padding-top: 100px;
    padding-bottom: 100px;
    background: #F7F7F7;

}
.frame-1-btn button {
    border-style: none;
    height: 48px;
    border-radius: 7px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
}
.btn-1 {
    background: #2D81EB;
    width: 192px;
    border-style: none;
    height: 48px;
    border-radius: 7px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn-2 {
    background: #1B2A50;
width: 225px;
border-style: none;
    height: 48px;
    border-radius: 7px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
}
.space-div {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.frame-1-btn  {
    display: flex;
    gap: 20px;
}
.frame-2-left h2 {
    color: #1B2A50;
    font-size: 60px;
    font-weight: 600;

}
.frame-2-left p {
    color: #565E6F;
    line-height: 23px;
    font-size: 18px;
    font-weight: 400;
    max-width: 513px;
}
.frame-2-left {
display: flex;
flex-direction: column;
gap: 20px;
}
.frame-2{ 
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 100px 0px;
}
.frame-3-img {
    display: grid;
grid-template-columns: repeat(2, 1fr);
gap: 5px; /* Reduces the space between images */
    justify-content: center; /* Centers the grid items */
    align-items: center;
}
/* .frame-3-img img {
    width: 141px;
    height: 141px;
} */
.frame-3-inner h4 {
    max-width: 312px;
    font-size: 22px;
    font-weight: 600;
    line-height: 24px;
    color: #ffffff;
}
.frame-3-inner p {
    color: #FFFFFFBF;
    max-width: 305px;
    font-size: 18px;
    font-weight: 400;
}
.frame-3-inner {
    border: 1px solid #FFFFFF2E;
    border-radius: 12px;
        padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding-bottom: 40px;
}
.frame-3-sub {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}
.frame-3 h2 {
    color: #FFFFFF;
    font-size: 60px;
    font-weight: 600;
    margin: auto;
    text-align: center;
padding-bottom: 30px;
}
.frame-3 {
    background: #1B2A50;
    padding-top: 100px;
    padding-bottom: 100px;
}
.frame-4-upper h2 {
font-weight: 700;
font-size: 60px;
color: #1B2A50;

}
.frame-4-upper p {
    color: #565E6F;
    font-weight: 400;
    line-height: 24px;
    font-size: 18px;
    max-width: 549px;

}
.frame-4-upper {
    display: flex;
    flex-direction: column;
    gap: 15px;
}
.frame-4-inner h4 {
    color: #1B2A50;
    font-size: 22px;
    font-weight: 600;

}
.frame-4-inner p {
    color: #565E6F;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    max-width: 296px;

}
.frame-4-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 357px !important;
}
.frame-4sub {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
}
.frame-4 {
    margin: 100px 0px;
    display: flex;
    flex-direction: column;
    gap: 50px;
}
@media (max-width: 1280px) {
    .frame-3-sub {
    grid-template-columns: repeat(2, 1fr);
}
}
@media (max-width: 992px) {
.frame-2  {
    flex-wrap: wrap;
    margin: 50px 0px;
}
.frame-1-btn {
    flex-direction: column;
    align-items: center;
}
.frame-1 {
    padding-top: 50px;
}
.frame-3 {
    padding-top: 50px;
    padding-bottom: 50px;
}
}
@media (max-width: 850px) {
    .frame-3-sub {
    grid-template-columns: repeat(1, 1fr);
}
}
@media (max-width: 500px) {
.frame-1  h2 {
    font-size: 50px;
}
.frame-1-btn {
    flex-wrap: wrap;
}
.frame-2  img {
    width: 350px;
}

}
@media (max-width: 400px) {
    .frame-2  img {
    width: 250px;
}
}



`

const Framework = () => {
    const dispatch = useDispatch()
  const { general } = useSelector((state) => state.others);

      const { framework, loading, error } = useSelector((state) => state.others);
      
const firstsection = framework?.data?.firstsection
const secondsection = framework?.data?.secondsection
const sixspheres = framework?.data?.sixspheres
const whatmatters = framework?.data?.whatmatters

         useEffect(() => {
                dispatch(fetchGeneralObject()); // Call API on component mount
              }, [dispatch]);
      useEffect(() => {
        dispatch(fetchFrameworkObject()); // Call API on component mount
      }, [dispatch]);
    return (
        <FrameworkRap>
            <div>
                <div className="frame-1 containers">
                    <h2>{firstsection?.title}</h2>
                    <p>{firstsection?.content}</p>
                    <div className="frame-1-btn">
                        <Link to={`${firstsection?.first_btn_link}`} className="btn-1">{firstsection?.first_btn_title}</Link >
                        <Link to={`${firstsection?.second_btn_link}`}  className="btn-2">{firstsection?.second_btn_title}</Link >
                    </div>
                </div>
                <div className="frame-2 containers">
                    <div className="frame-2-left">
                        <h2>{secondsection?.title}</h2>
                        <div className="space-div" dangerouslySetInnerHTML={{ __html: secondsection?.content }}></div>
                    </div>
                    <img src={secondsection?.banner} alt="" />
                </div>
                <div className="frame-3 containers">
                    <h2>{sixspheres?.title?.title}</h2>
                    <div className="frame-3-sub">
                        {sixspheres?.lists.map((item, index) => (
                        <div className="frame-3-inner">
                       
                        <h4>{item?.title}</h4>
                        <p>{item?.content}</p>
                        <div className="frame-3-img">
                        {item?.Images.map((img, imgIndex) => {
  // Default size
  let size = item.Images.length === 2 ? 141 : 76;

  // Reduce size on smaller screens
  if (window.innerWidth <= 500) {
    size = item.Images.length === 2 ? 100 : 76;
  }

  return (
    <img
      key={imgIndex}
      src={img?.image}
      alt={`Image ${imgIndex + 1}`}
      width={size}
      height={size}
      style={{ objectFit: "cover", margin: "5px" }}
    />
  );
})}

                        </div>
                    </div>
                        ))}
                    </div>
                </div>
                <div className="frame-4 containers">
                    <div className="frame-4-upper">
                        <h2>{whatmatters?.titles?.title}</h2>
                        <p>{whatmatters?.titles?.content}.</p>
                    </div>
                    <div className="frame-4sub">
                        {whatmatters?.lists.map((items, index) => (
                        <div className="frame-4-inner">
                        <h4>{items?.title}</h4>
                        <p>{items?.content}</p>
                    </div>
                        ))}

                       
                    </div>
                </div>
            </div>
        </FrameworkRap>
    )
}

export default Framework